<app-empty-state [type]="getLogoType()">
    <div class="questionnaire-info-container">
        @if (customerQuestionnaireService.areAllQuestionsAnswered()) {
        <span i18n>
            This was the final question in the questionnaire. Please click on the Submit button to send your completed answers to CIFC. This
            will enable them to build the threat profile specifically tailored for your company.
        </span>
        } @if (!customerQuestionnaireService.areAllQuestionsAnswered()) {
        <span i18n>
            This was the final question in the questionnaire. Once you have answered all the mandatory questions, you can click the Submit
            button to send your completed answers to CIFC. This will enable them to build the threat profile specifically tailored for your
            company. We recommend answering all the questions to ensure a comprehensive threat profile and maximum protection. To go back to
            the first unanswered question, click on Continue.
        </span>
        }
    </div>
    <br />
    @if (enableContinueButton()) {
    <button
        id="start-questionnaire-button"
        mat-flat-button
        color="primary"
        type="submit"
        class="m-t-20"
        (click)="onResumeQuestionnaire($event)"
        i18n
    >
        Continue
    </button>
    }
</app-empty-state>
